export default __webpack_public_path__ + "static/media/vat_grown_scrap.c19f7954.mp3";